import Route from '@ember/routing/route'

export default class extends Route {
  queryParams = {
    page: {
      replace: true,
    },
    size: {
      replace: true,
    },
    sort: {
      replace: true,
    },
    status: {
      replace: true,
    },
  }
}
